import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'; // We are using App.css for all styles now
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);